export function Home({ className }: { className?: string }) {
    return (
      <svg
        className={className}
        width="1em"
        height="1em"
        viewBox="0 0 16 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="home-2--door-entrance-home-house-roof-round-shelter">
          <path
            id="Union"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.34937 0.317298C7.9263 -0.105766 7.24037 -0.105766 6.8173 0.317298L0.317301 6.8173C-0.105767 7.24037 -0.105767 7.9263 0.317301 8.34937C0.740369 8.77243 1.4263 8.77243 1.84937 8.34937L2.16667 8.03206V11.9167C2.16667 12.515 2.6517 13 3.25 13H6.5V9.75C6.5 9.1517 6.98503 8.66667 7.58333 8.66667C8.18164 8.66667 8.66667 9.1517 8.66667 9.75V13H11.9167C12.515 13 13 12.515 13 11.9167V8.03206L13.3173 8.34937C13.7403 8.77243 14.4263 8.77243 14.8494 8.34937C15.2724 7.9263 15.2724 7.24037 14.8494 6.8173L8.34937 0.317298Z"
            fill="currentcolor"
          />
        </g>
      </svg>
    );
  }
  